import { BackgroundService } from './BackgroundService'

export const backgroundService = new BackgroundService()
